import { b as _createClass, c as _classCallCheck, e as _defineProperty, k as _asyncToGenerator, l as _regeneratorRuntime } from './_rollupPluginBabelHelpers-047e4aae.js';
import Bole from './bole.js';

var FEATURE_CONTEXT_KEYS = {
  BUSINESS_VIA_NAME: "business_via_names",
  PARTNER: "partner_names",
  DOMAIN: "domain_names"
};

/**
 * Utility function to sanitize dangerouslySetInnerHtml
 * @param str String/data which is to be sanitized
 */
var htmlEscape = function htmlEscape(str) {
  return String(str).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
};

/**
 * Returns all the feature toggles available
 * @param baseURL Base URL for cas/env via which this will be called
 */
var getFeatureToggles = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(baseURL) {
    var url, returnData;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          url = "".concat(baseURL, "/get_feature_toggles/");
          returnData = {
            success: false,
            data: {}
          };
          _context.next = 4;
          return fetch(url).then(function (response) {
            return response.json();
          }).then(function (data) {
            if (data.body) {
              returnData.success = true;
              returnData.data = data.body;
            }
          })["catch"](function (error) {
            Bole.error(error);
          });
        case 4:
          return _context.abrupt("return", returnData);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getFeatureToggles(_x) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Checks if the Feature is enabled for a particular context
 * @param featureData Features recieved from getFeatureToggles()
 * @param feature Name of the feature to check
 */
var IsFeatureEnabled = /*#__PURE__*/_createClass(function IsFeatureEnabled(featureData, featureName) {
  var _this = this;
  _classCallCheck(this, IsFeatureEnabled);
  /**
   * Checks if business is present in feature data
   * @param businessViaName Name of the business to verify
   */
  _defineProperty(this, "forBusiness", function (businessViaName) {
    var businessData = [];
    if (_this.featureData[_this.featureName]) {
      businessData = _this.featureData[_this.featureName][FEATURE_CONTEXT_KEYS.BUSINESS_VIA_NAME];
    }
    return businessData.includes(businessViaName);
  });
  /**
   * Checks if partner is present in feature data
   * @param partner Name of the partner to verify
   */
  _defineProperty(this, "forPartner", function (partner) {
    var partnerData = [];
    if (_this.featureData[_this.featureName]) {
      partnerData = _this.featureData[_this.featureName][FEATURE_CONTEXT_KEYS.PARTNER];
    }
    return partnerData.includes(partner);
  });
  /**
   * Checks if domain/bot is present in feature data
   * @param domain Name of the domain/bot to verify
   */
  _defineProperty(this, "forDomain", function (domain) {
    var domainData = [];
    if (_this.featureData[_this.featureName]) {
      domainData = _this.featureData[_this.featureName][FEATURE_CONTEXT_KEYS.DOMAIN];
    }
    return domainData.includes(domain);
  });
  this.featureData = featureData;
  this.featureName = featureName;
});
var PlatformUtils = {
  htmlEscape: htmlEscape,
  getFeatureToggles: getFeatureToggles,
  IsFeatureEnabled: IsFeatureEnabled
};

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': PlatformUtils
});

export { PlatformUtils as P, index as i };
